import store from '@/store'
import Vue from 'vue'
import Router from 'vue-router'
// import Booking from "./pages/Booking";
// const NewOrder = () =>  import("@/components/pages/NewOrder");
import OrderList from './pages/OrderList'
import OrderListV2 from './pages/OrderListV2'

// const CallbackLogs = () => import("./pages/CallbackLogs");
// const Visualization = () => import("./pages/Visualization");
const Documentation = () => import('./pages/Documentation')
const Dashboard = () => import('./pages/Dashboard')

const Auth = () => import('./pages/Auth')
const Activate = () => import('@/components/pages/Activate')

const Profile = () => import('@/components/pages/Profile')
const RecordDetail = () => import('@/components/pages/RecordDetail')
const Employees = () => import('./pages/Employees')
const VerifyOrder = () => import('@/components/pages/VerifyOrder')
const EmbeddedPage = () => import('./pages/EmbeddedPage')
const OnwheelEmbedPage = () => import('./pages/OnwheelEmbedPage')
const OnwheelFrontendReactJSEmbedPage = () => import('./pages/OnwheelFrontendReactJSEmbedPage')
const BillOfLading = () => import('./../partner/pages/BillOfLading')
const Invoice = () => import('@/onwheel/pages/Invoice')

const NationwidePage = () =>
  import(
    /* webpackChunkName: "nationwide-page" */
    '@/onwheel/components/nationwide/NationwidePage'
  )

const OAuthAuthorize = () => import('@/components/oauth/OAuthAuthorize')

const DeliveryOptimization = () =>
  import(
    /* webpackChunkName: "delivery-optimization" */
    '@/components/pages/DeliveryOptimization'
  )

const DeliveryOptimizationSGC = () =>
  import(
    /* webpackChunkName: "delivery-optimization" */
    '@/onwheel/pages/DeliveryOptimizationSGC.vue'
  )

const DeliveryOptimizationAC = () =>
  import(
    /* webpackChunkName: "delivery-optimization" */
    '@/onwheel/pages/DeliveryOptimizationAC.vue'
  )

const BigCOutbound = () =>
  import(
    /* webpackChunkName: "bigc-outbound" */
    '@/onwheel/pages/BigCOutbound.vue'
  )
const DeliveryOptimizationV3 = () => import('../components/pages/RouteOptimiztionV3.vue')

// Silence uncatch error of "push" vue router
// https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/records',
      name: 'records',
      component: OrderList,
      meta: { requiresAuth: true, containerFluid: true, hideHeader: true }
    },
    {
      path: '/records-v2',
      name: 'records',
      component: OrderListV2,
      meta: { requiresAuth: true, containerFluid: true, hideHeader: true }
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      component: Auth,
      meta: {
        containerFluid: true,
        hideHeader: true,
        customData: {
          login_type: 'saas'
        }
      }
    },
    {
      path: '/activate',
      name: 'activate',
      component: Activate,
      meta: {
        hideHeader: true,
        customData: {
          login_type: 'saas'
        }
      }
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      component: Auth,
      meta: {
        containerFluid: true,
        hideHeader: true,
        customData: {
          login_type: 'saas'
        }
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/record/:id/:ownerId',
      name: 'record_detail',
      component: RecordDetail,
      meta: { requiresAuth: true, containerFluid: true }
    },
    {
      path: '/employees',
      name: 'employees',
      component: Employees,
      meta: { requiresAuth: true, containerFluid: true, saas: true, partner: true }
    },
    {
      path: '/verify-order',
      name: 'verify_order',
      component: VerifyOrder,
      meta: { requiresAuth: true, containerFluid: true }
    },
    {
      path: '/docs',
      name: 'documentation',
      component: Documentation,
      meta: { containerFluid: true, hideHeader: true }
    },
    {
      path: '/dashboards',
      name: 'dashboards',
      component: Dashboard,
      meta: { requiresAuth: true, containerFluid: true, hideHeader: true }
    },
    {
      path: '/feature/onwheel-admin-v3',
      name: 'embedded_onwheel_admin_v3',
      component: OnwheelEmbedPage,
      meta: { requiresAuth: true, containerFluid: true, hideHeader: true }
    },
    {
      path: '/feature/v3',
      name: 'embedded_frontend-reactjs',
      component: OnwheelFrontendReactJSEmbedPage,
      meta: { requiresAuth: true, containerFluid: true, hideHeader: true }
    },
    {
      path: '/feature',
      name: 'embedded',
      component: EmbeddedPage,
      meta: { requiresAuth: true, containerFluid: true, hideHeader: true }
    },
    {
      path: '/route-optimization',
      name: 'route_optimization',
      component: DeliveryOptimization,
      meta: { containerFluid: true, hideHeader: true, requiresAuth: true }
    },
    {
      path: '/bigc-outbound',
      name: 'bigc_outbound',
      component: BigCOutbound,
      meta: { containerFluid: true, saas: true, requiresAuth: true }
    },
    {
      path: '/v3/ro-tool',
      name: 'route_optimization_delivery',
      component: DeliveryOptimizationV3,
      meta: { containerFluid: true, hideHeader: true, requiresAuth: true }
    },
    {
      path: '/route-optimization-sgc',
      name: 'route_optimization_sgc',
      component: DeliveryOptimizationSGC,
      meta: { containerFluid: true, hideHeader: true, requiresAuth: true }
    },
    {
      path: '/route-optimization-ac',
      name: 'route_optimization_ac',
      component: DeliveryOptimizationAC,
      meta: { containerFluid: true, hideHeader: true, requiresAuth: true }
    },
    {
      path: '/bill',
      name: 'bill',
      component: BillOfLading,
      meta: { containerFluid: true, hideHeader: true }
    },
    {
      path: '/invoice',
      name: 'bill',
      component: Invoice,
      meta: { containerFluid: true, hideHeader: true }
    },
    {
      path: '/nationwide',
      name: 'nationwide',
      component: NationwidePage,
      meta: { containerFluid: true, hideHeader: true, requiresAuth: true }
    },
    {
      path: '/oauth/authorize',
      name: 'oauth_authorize',
      component: OAuthAuthorize,
      meta: {
        requiresAuth: false,
        containerFluid: true,
        hideHeader: true,
        hideSidebar: true
      }
    },
    {
      path: '*',
      redirect: '/profile'
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const token = store.getters.token || Vue.prototype.$cookie.get('token')
    if (!token) {
      next({
        path: '/sign-in'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
